// Petite roue d'attente pendant qu'un morceau de page arrive.
// SVG animé sans CSS, couleur héritée (currentColor), aucun texte.
export default function Chargement() {
  return (
    <div role="status" aria-label="Chargement" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 40, color: "#9CA3AF" }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
        <path d="M12 3a9 9 0 1 0 9 9">
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>
  );
}
